var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.79 2.88C25.49 1.75 24.59 0.85 23.46 0.55C21.41 1.78814e-07 13.17 0 13.17 0C13.17 0 4.93001 1.78814e-07 2.88 0.55C1.75 0.85 0.849988 1.75 0.549988 2.88C-1.2219e-05 4.93 0 9.22 0 9.22C0 9.22 -1.2219e-05 13.51 0.549988 15.56C0.849988 16.69 1.75 17.59 2.88 17.89C4.93001 18.44 13.17 18.44 13.17 18.44C13.17 18.44 21.41 18.44 23.46 17.89C24.59 17.59 25.49 16.69 25.79 15.56C26.34 13.51 26.34 9.22 26.34 9.22C26.34 9.22 26.34 4.93 25.79 2.88ZM10.54 13.17V5.27L17.38 9.22L10.54 13.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d4199fc9b086fd3ddf775dc64944da7b.svg";
export { ForwardRef as ReactComponent };